import { render, staticRenderFns } from "./misc-list.vue?vue&type=template&id=2a5938eb&scoped=true&"
import script from "./misc-list.vue?vue&type=script&lang=js&"
export * from "./misc-list.vue?vue&type=script&lang=js&"
import style0 from "./misc-list.vue?vue&type=style&index=0&id=2a5938eb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5938eb",
  null
  
)

export default component.exports